import { render, staticRenderFns } from "./InstitutionProfile.vue?vue&type=template&id=6edf12cd&"
import script from "./InstitutionProfile.vue?vue&type=script&lang=js&"
export * from "./InstitutionProfile.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports